import styled from '@emotion/styled';
import { captionSb } from '@teamsparta/stack-font';

export const TreeWrapper = styled.div`
  position: relative;
  width: 300px;
  height: 480px;
  background-color: #f8fafc;
  border-radius: 4px;
  border: 1px solid black;
  overflow: hidden;
`;

export const PhaseCountText = styled.div`
  ${captionSb};
  color: #009f65;
  text-align: center;
  margin: 0 auto;

  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre-line;
`;
